const onEnter = ({ event, callback, enabled = true }) => {
  if (!enabled) return;
  if (event.key === 'Enter') {
    callback();
  }
};

export default onEnter;
